<div class="question-wrapper">
  <div
    class="card question-card"
    (click)="handleCardClick(question)"
    [ngClass]="[editMode ? 'editMode' : '']">
    <div class="drag-row" cdkDragHandle>
      <div
        class="drag-handle phase-handle d-flex justify-content-center align-items-center">
        <i class="bi bi-grip-horizontal"></i>
      </div>
    </div>
    @if (question) { @if(!editMode) {
    <div class="preview-wrapper">
      <div class="preview-question">
        <app-safehtml [html]="question.question"></app-safehtml>
      </div>
      @if(question.helper_text) {
      <div class="preview-description">
        <app-safehtml [html]="question.helper_text"></app-safehtml>
      </div>
      }
      <div class="preview-type">
        @if (question.field_type === ProformFieldTypes.TEXTAREA) { LONG TEXT }
        @else if (question.field_type === ProformFieldTypes.SCALE) { LINEAR
        SCALE } @else if (question.field_type ===
        ProformFieldTypes.CHECKBOX_GRID) { CHECKBOX GRID } @else if
        (question.field_type === ProformFieldTypes.CONTENT_BLOCK){ CONTENT BLOCK
        } @else {
        <p>{{ question.field_type | uppercase }}</p>
        }
      </div>
      <div class="preview-body">
        <!-- ANSWER PREVIEW COMPONENTS WILL GO HERE -->
        @if(question.field_type === ProformFieldTypes.TEXT ||
        question.field_type === ProformFieldTypes.TEXTAREA) {
        <app-proforms-question-answer-text [question]="question" />
        } @else if(question.field_type === ProformFieldTypes.RADIO ||
        question.field_type === ProformFieldTypes.CHECKBOX ||
        question.field_type === ProformFieldTypes.DROPDOWN) {
        <app-proforms-question-answer-options [question]="question" />
        } @else if(question.field_type === ProformFieldTypes.ATTACHMENT) {
        <app-proforms-question-answer-attachment [question]="question" />
        } @else if (question.field_type === ProformFieldTypes.SCALE) {
        <app-proforms-question-answer-scale [question]="question" />
        } @else if (question.field_type === ProformFieldTypes.RUBRIC) {
        <app-proforms-question-answer-rubric [question]="question" />
        } @else if (question.field_type === ProformFieldTypes.CHECKBOX_GRID) {
        <app-proforms-question-answer-checkbox-grid [question]="question" />
        }
      </div>
    </div>
    } @else {
    <div class="qcard-content">
      <div class="d-flex flex-column flex-lg-row w-100 align-items-top">
        <div
          class="question mb-2"
          *ngIf="question.field_type !== ProformFieldTypes.CONTENT_BLOCK">
          <app-ck-editor
            #titleEditor
            [minHeight]="'5px'"
            [editorType]="'inline'"
            [version]="'mini'"
            [initialData]="question.question"
            (contentChange)="updateLocalQuestionTitle($event)"
            [channelId]="'proforms_content_block.' + question.id" />
        </div>
        <div
          class="type mb-2"
          [ngClass]="{
            'ms-lg-2': question.field_type !== ProformFieldTypes.CONTENT_BLOCK,
            'w-100': question.field_type === ProformFieldTypes.CONTENT_BLOCK,
          }">
          <ng-select
            id="type"
            autocomplete="off"
            [items]="proFormQuestionTypes"
            [searchable]="false"
            [clearable]="false"
            bindLabel="label"
            bindValue="value"
            [(ngModel)]="selectedFieldType"
            (ngModelChange)="handleTypeChange()">
            <ng-template ng-label-tmp let-item="item">
              @if (item.value === ProformFieldTypes.TEXT) {
              <div class="sel-icon">
                <i class="bi bi-input-cursor-text"></i> {{ item.label }}
              </div>
              } @if (item.value === ProformFieldTypes.TEXTAREA) {
              <div class="sel-icon">
                <i class="bi bi-justify-left"></i> {{ item.label }}
              </div>
              } @if (item.value === ProformFieldTypes.RADIO) {
              <div class="sel-icon">
                <img
                  class="svg-icon"
                  src="/assets/proforms/icon-radio.svg"
                  alt="Radio Icon" />
                {{ item.label }}
              </div>
              } @if (item.value === ProformFieldTypes.CHECKBOX) {
              <div class="sel-icon">
                <i class="bi bi-check-square"></i> {{ item.label }}
              </div>
              } @if (item.value === ProformFieldTypes.CHECKBOX_GRID) {
              <div class="sel-icon">
                <i class="bi bi-ui-checks-grid"></i> {{ item.label }}
              </div>
              } @if (item.value === ProformFieldTypes.DROPDOWN) {
              <div class="sel-icon">
                <img
                  class="svg-icon"
                  src="/assets/proforms/icon-dropdown.svg"
                  alt="Dropdown Icon" />
                {{ item.label }}
              </div>
              } @if (item.value === ProformFieldTypes.ATTACHMENT) {
              <div class="sel-icon">
                <i class="bi bi-upload"></i> {{ item.label }}
              </div>
              } @if (item.value === ProformFieldTypes.SCALE) {
              <div class="sel-icon">
                <img
                  class="svg-icon"
                  src="/assets/proforms/icon-linear-scale.svg"
                  alt="Scale Icon" />
                {{ item.label }}
              </div>
              } @if (item.value === ProformFieldTypes.RUBRIC) {
              <div class="sel-icon">
                <i class="bi bi-1-square"></i>
                {{ item.label }}
              </div>
              } @if (item.value === ProformFieldTypes.CONTENT_BLOCK) {
              <div class="sel-icon">
                <i class="bi bi-card-text"></i> {{ item.label }}
              </div>
              }
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              @if (item.value === ProformFieldTypes.TEXT) {
              <div class="sel-icon">
                <i class="bi bi-input-cursor-text"></i> {{ item.label }}
              </div>
              } @if (item.value === ProformFieldTypes.TEXTAREA) {
              <div class="sel-icon">
                <i class="bi bi-justify-left"></i> {{ item.label }}
              </div>
              } @if (item.value === ProformFieldTypes.RADIO) {
              <div class="sel-icon">
                <img
                  class="svg-icon"
                  src="/assets/proforms/icon-radio.svg"
                  alt="Radio Icon" />
                {{ item.label }}
              </div>
              } @if (item.value === ProformFieldTypes.CHECKBOX) {
              <div class="sel-icon">
                <i class="bi bi-check-square"></i> {{ item.label }}
              </div>
              } @if (item.value === ProformFieldTypes.CHECKBOX_GRID) {
              <div class="sel-icon">
                <i class="bi bi-ui-checks-grid"></i> {{ item.label }}
              </div>
              } @if (item.value === ProformFieldTypes.DROPDOWN) {
              <div class="sel-icon">
                <img
                  class="svg-icon"
                  src="/assets/proforms/icon-dropdown.svg"
                  alt="Dropdown Icon" />
                {{ item.label }}
              </div>
              } @if (item.value === ProformFieldTypes.ATTACHMENT) {
              <div class="sel-icon">
                <i class="bi bi-upload"></i> {{ item.label }}
              </div>
              } @if (item.value === ProformFieldTypes.SCALE) {
              <div class="sel-icon">
                <img
                  class="svg-icon"
                  src="/assets/proforms/icon-linear-scale.svg"
                  alt="Scale Icon" />
                {{ item.label }}
              </div>
              } @if (item.value === ProformFieldTypes.RUBRIC) {
              <div class="sel-icon">
                <i class="bi bi-1-square"></i> {{ item.label }}
              </div>
              } @if (item.value === ProformFieldTypes.CONTENT_BLOCK) {
              <div class="sel-icon">
                <i class="bi bi-card-text"></i> {{ item.label }}
              </div>
              }
            </ng-template>
          </ng-select>
        </div>
      </div>
      <div
        class="d-flex flex-column flex-lg-row w-100"
        *ngIf="question.field_type !== ProformFieldTypes.CONTENT_BLOCK">
        <div class="description-label">Description</div>
        <div class="description-content">
          <app-ck-editor
            #descriptioneditor
            [minHeight]="'5px'"
            [editorType]="'inline'"
            [version]="'mini'"
            [initialData]="question.helper_text"
            (contentChange)="updateLocalDescription($event)" />
        </div>
      </div>
    </div>
    <ng-container
      *ngIf="
        this.form &&
        this.form.type === 'quiz' &&
        (question.field_type === ProformFieldTypes.CHECKBOX ||
          question.field_type === ProformFieldTypes.RADIO)
      ">
      <div
        class="d-flex justify-content-start align-items-center pb-1"
        style="padding: 0 23px; font-size: 1.2rem">
        <input
          checked
          disabled
          class="form-check-input"
          style="margin-left: 7px"
          type="checkbox"
          role="switch"
          aria-label="coaching-sessions-page-me-mode" />
        <div class="ms-2">
          Mark the correct answer<span
            *ngIf="question.field_type === ProformFieldTypes.CHECKBOX"
            >(s)</span
          >
        </div>
      </div>
    </ng-container>
    <div class="separator"></div>
    <div class="qcard-body">
      <div
        style="padding: 0 28px"
        *ngIf="
          question.field_type !== ProformFieldTypes.CONTENT_BLOCK;
          else contentBlockTemplate
        ">
        @if(question.field_type === ProformFieldTypes.TEXT ||
        question.field_type === ProformFieldTypes.TEXTAREA) {
        <app-proforms-question-answer-text [question]="question" />
        } @else if (question.field_type === ProformFieldTypes.RADIO ||
        question.field_type === ProformFieldTypes.CHECKBOX ||
        question.field_type === ProformFieldTypes.DROPDOWN) {
        <app-proforms-admin-question-answer-options
          #answerOptionsComponent
          [question]="question" />
        } @else if (question.field_type === ProformFieldTypes.ATTACHMENT) {
        <app-proforms-question-answer-attachment [question]="question" />
        } @else if (question.field_type === ProformFieldTypes.SCALE) {
        <app-proforms-admin-question-answer-scale [question]="question" />
        } @else if (question.field_type === ProformFieldTypes.RUBRIC) {
        <app-proforms-admin-question-answer-rubric [question]="question" />
        } @else if (question.field_type === ProformFieldTypes.CHECKBOX_GRID) {
        <app-proforms-admin-question-answer-checkbox-grid
          #checkboxGridComponent
          [question]="question" />
        }
      </div>
      <ng-template #contentBlockTemplate>
        <div style="padding: 0 22px">
          <app-ck-editor
            [initialData]="initialQuestionContent"
            [version]="'full'"
            [minHeight]="'250px'"
            (contentChange)="updateLocalQuestionTitle($event)">
          </app-ck-editor>
        </div>
      </ng-template>
    </div>
    <div class="qcard-footer d-flex justify-content-end align-items-center">
      <div
        *ngIf="question.field_type !== ProformFieldTypes.CONTENT_BLOCK"
        class="required d-flex justify-content-between align-items-center">
        Required:
        <button
          aria-label="required-button"
          class="form-switch btn-reset ms-2 me-2">
          <input
            class="form-check-input cursor-pointer"
            type="checkbox"
            role="switch"
            [checked]="question.required === 1"
            (change)="toggleRequired($event); $event.stopPropagation()" />
        </button>
      </div>

      <button
        aria-label="Delete Question"
        class="btn btn-delete"
        type="button"
        [autoClose]="'outside'"
        [ngbPopover]="deleteQuestionTemplate"
        [popoverTitle]="'Delete question'"
        #popover="ngbPopover">
        <i class="bi bi-trash"></i>
      </button>
      <ng-template #deleteQuestionTemplate>
        Are you sure you want to delete this question?
        <div class="text-end mt-2">
          <button
            type="button"
            class="btn btn-secondary btn-sm px-3 m-1"
            (click)="popover.close()">
            No
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm px-3 m-1"
            (click)="
              deleteQuestion(question.id, question.proform_form_section_id);
              popover.close()
            ">
            Yes
          </button>
        </div>
      </ng-template>
    </div>
    } }
  </div>
  @if(editMode) {
  <app-proforms-add-form-item
    [id]="question.id"
    [sectionId]="question.proform_form_section_id"
    [static]="true" />
  }
</div>

<app-modal
  #typeChangeConfirmModal
  [modalConfig]="{
    titleText: 'Change Question Type',
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    windowClass: 'custom-class',
    customFooter: true,
  }">
  <button
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="typeChangeConfirmModal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  Are you sure you want to change the question type? This will delete all the
  existing @if (isContentBlockChange) { content. } @else { answers and options.
  }
  <div footerContent>
    <div class="d-flex justify-content-between">
      <button
        type="button"
        class="btn"
        (click)="typeChangeConfirmModal.close()">
        Cancel
      </button>
      <button
        (click)="confirmTypeChange()"
        type="button"
        class="btn btn-md btn-primary">
        Yes, change type
      </button>
    </div>
  </div>
</app-modal>
